import getConfig from 'next/config';

export const isProductCacheEnabled = (): boolean => {
  const { publicRuntimeConfig } = getConfig();

  if (publicRuntimeConfig && publicRuntimeConfig.ENABLE_PRODUCT_CACHE) {
    return publicRuntimeConfig.ENABLE_PRODUCT_CACHE.toLowerCase() === 'true';
  }
  return false;
};
